// @Version: 1.0.0
import {Injectable} from "@angular/core";
import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";
import {Subject} from "rxjs";
import {filter, map} from "rxjs/operators";
import {Location} from "@angular/common";

@Injectable({
   providedIn: "root"
})
export class ReloadService {

   private dataPage = new Subject<string>();
   public reloadPage$ = this.dataPage.asObservable();
   private location: Location;

   constructor (private router: Router, private activatedRoute: ActivatedRoute, location: Location) {
      this.location = location;
   }

   private updateReload (url: string): void {
      this.dataPage.next(url);
   }

   public initReloadService () {
      this.router.events.pipe(
         filter(event => event instanceof NavigationEnd),
         map(() => {
            let child = this.activatedRoute.firstChild;
            while (child?.firstChild) {
               child = child.firstChild;
            }
            return this.location.path();
         })
      ).subscribe((ttl: string) => this.updateReload(ttl));
   }
}
